import { render } from "./ChangeLog.vue?vue&type=template&id=ade5d6f8"
import script from "./ChangeLog.vue?vue&type=script&lang=ts"
export * from "./ChangeLog.vue?vue&type=script&lang=ts"
script.render = render

export default script